import React from 'react';
import { classes, st } from './AgendaItem.st.css';
import { useDailyAgendaActions } from '../../../../../components/DailyAgenda/hooks/useDailyAgendaActions';
import {
  AgendaItemViewModel,
  LayoutTypes,
} from '../../../../../components/DailyAgenda/viewModel/agendaViewModel/agendaViewModel';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { agendaItemLayoutFactory } from './AgendaItemLayoutFactory';

export type AgendaItemProps = {
  layoutType: LayoutTypes;
  agendaItemViewModel: AgendaItemViewModel;
};

export const AgendaItem: React.FC<AgendaItemProps> = ({
  layoutType,
  agendaItemViewModel,
}) => {
  const { onSlotClick } = useDailyAgendaActions();
  const { isMobile } = useEnvironment();
  const RenderAgendaItemLayout = agendaItemLayoutFactory[layoutType];

  return (
    <div className={st(classes.root, { layoutType, isMobile })}>
      <RenderAgendaItemLayout
        key={agendaItemViewModel.slotId}
        onSlotClick={onSlotClick}
        agendaItemViewModel={agendaItemViewModel}
      />
    </div>
  );
};
